import { render, staticRenderFns } from "./UserCustomerAttribute.vue?vue&type=template&id=3cc3d8b6&scoped=true&"
import script from "./UserCustomerAttribute.vue?vue&type=script&lang=js&"
export * from "./UserCustomerAttribute.vue?vue&type=script&lang=js&"
import style0 from "./UserCustomerAttribute.vue?vue&type=style&index=0&id=3cc3d8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3d8b6",
  null
  
)

export default component.exports